import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "app/actions";
import { RootState } from "app/store";
import { fetchSlots, linkSlots } from "app/thunks/slotsAPI";
import { Slot } from "interfaces/Slot";

export interface State {
  list: Slot[];
  isFetching: boolean;
  isLinking: boolean;
  isError: boolean;
  error: any;
}

const initialState: State = {
  list: [],
  isFetching: false,
  isLinking: false,
  isError: false,
  error: undefined,
};

export const slotsSlice = createSlice({
  name: "slots",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
    builder.addCase(fetchSlots.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(fetchSlots.rejected, (state, action) => {
      state.isError = true;
      state.isFetching = false;
      state.error = action.payload;
    });
    builder.addCase(fetchSlots.fulfilled, (state, action) => {
      state.isFetching = false;
      state.error = undefined;
      state.list = action.payload as unknown as Slot[];
    });
    builder.addCase(linkSlots.pending, (state) => {
      state.isLinking = true;
    });
    builder.addCase(linkSlots.rejected, (state, action) => {
      state.isLinking = false;
      state.isError = true;
      state.error = action.payload;
    });
    builder.addCase(linkSlots.fulfilled, (state) => {
      state.isLinking = false;
      state.error = undefined;
    });
  },
});

// ------ Selectors ------
export const getSlotState = (state: RootState) => ({
  isFetching: state.slots.isFetching,
  isLinking: state.slots.isLinking,
  isError: state.slots.isError,
  error: state.slots.error,
  slots: state.slots.list,
});

export default slotsSlice.reducer;
